import { Route, Routes, useLocation } from "react-router-dom";
import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";
import Home from "./Home";
import PrivacyPolicy from "./PrivacyPolicy";
import ShippingPolicy from "./ShippingPolicy";
import TermsAndConditions from "./TermsAndConditions";
import Footer from "./components/Footer";
import HeaderOne from "./components/Header/HeaderOne";
import HeaderTwo from "./components/Header/HeaderTwo";
import ProductDetail from "./components/ProductDetail";
import ScrollToTop from "./components/ScrollToTop";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AddProduct from "./pages/Product/AddProduct";
import ViewProducts from "./pages/Product/ViewProducts";
import AddCategory from "./pages/Category/AddCategory";
import ViewCategories from "./pages/Category/ViewCategories";
import AddBrand from "./pages/Brand/AddBrand";
import ViewBrands from "./pages/Brand/ViewBrands";
import Shop from "./Shop";
import ImportProducts from "./pages/Product/ImportProducts";
import ProtectedRoute from "./ProtectedRoute";
import Category from "./pages/Category";
import Profile from "./pages/Profile";
import ContactAdmin from "./pages/ContactAdmin";
import Users from "./pages/Users";
import StatsDetail from "./pages/StatsDetail";
import AdminStatsDetail from "./pages/Dashboard/StatsDetail";
import ReturnRefundPolicy from "./ReturnRefundPolicy";
import WarrantyInformation from "./WarrantyInformation";
import BillingPolicy from "./BillingPolicy";
import NotFound404 from "./pages/NotFound404";
import BackToTop from "./components/BackToTop";

// Admin Pages

function App() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  // Hide header and footer on login and admin dashboard pages only
  const isLoginPage = location.pathname === "/tech-login-478";
  const adminPaths = [
    "/dashboard",
    "/product/add",
    "/product/view",
    "/product/import",
    "/category/add",
    "/category/view",
    "/brand/add",
    "/brand/view",
    "/profile",
    "/contact/messages",
    "/users",
    "/dashboard/data-detail",
  ];
  const isDashboardPage = adminPaths.some((path) =>
    location.pathname.startsWith(path)
  );
  const showHeaderFooter = !isLoginPage && !isDashboardPage;

  return (
    <>
      <ScrollToTop />
      {showHeaderFooter && (isHome ? <HeaderOne /> : <HeaderTwo />)}

      <Routes>
        {/* Frontend Routes */}
        <Route path="*" element={<NotFound404 />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/return-refund-policy" element={<ReturnRefundPolicy />} />
        <Route path="/warranty-information" element={<WarrantyInformation />} />
        <Route path="/billing-policy" element={<BillingPolicy />} />

        <Route path="/shop" element={<Shop />} />
        <Route path="/category" element={<Category />} />
        <Route path="/category/:slug" element={<Shop />} />
        <Route path="/product/:slug" element={<ProductDetail />} />
        <Route path="/data-detail" element={<StatsDetail />} />
        {/* Admin Routes */}
        <Route path="/tech-login-478" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/product/add"
          element={
            <ProtectedRoute permission="product_add">
              <AddProduct />
            </ProtectedRoute>
          }
        />
        <Route
          path="/product/view"
          element={
            <ProtectedRoute permission="product_view">
              <ViewProducts />
            </ProtectedRoute>
          }
        />
        <Route
          path="/product/import"
          element={
            <ProtectedRoute permission="product_import">
              <ImportProducts />
            </ProtectedRoute>
          }
        />

        <Route
          path="/category/add"
          element={
            <ProtectedRoute permission="category_add">
              <AddCategory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/category/view"
          element={
            <ProtectedRoute permission="category_view">
              <ViewCategories />
            </ProtectedRoute>
          }
        />
        <Route
          path="/brand/add"
          element={
            <ProtectedRoute permission="brand_add">
              <AddBrand />
            </ProtectedRoute>
          }
        />
        <Route
          path="/brand/view"
          element={
            <ProtectedRoute permission="brand_view">
              <ViewBrands />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contact/messages"
          element={
            <ProtectedRoute permission="contact_access">
              <ContactAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute permission="user_manage">
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/data-detail"
          element={
            <ProtectedRoute>
              <AdminStatsDetail />
            </ProtectedRoute>
          }
        />
      </Routes>

      {showHeaderFooter && <Footer />}
      <BackToTop />
    </>
  );
}

export default App;
